import { render } from "./FiltersSection.vue?vue&type=template&id=72e1820a"
import script from "./FiltersSection.vue?vue&type=script&lang=js"
export * from "./FiltersSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__